//Клиент гугла
export const GOOGLE_CLIENT_ID: string = '887371495810-ng839goafhbfavmi6in55tgt26cfk5cr.apps.googleusercontent.com';


//АПИ для продакшена
export const PROD_API_URL: string = 'https://dashboard.yoola.com/';
export const PROD_HUB_URI: string = 'https://ymp-hub.yoola.com/';
//АПИ для дэв
export const DEV_API_URL: string = 'https://dashboard.dev.yoola.com/';
export const DEV_HUB_URI: string = 'https://ymp-hub-dev.yoola.com/';
// export const DEV_API_URL: string = 'http://10.0.0.6/';


//WS для продакшена
export const PROD_WS_URL: string = 'https://finance.yoola.app';
//WS для дэв
export const DEV_WS_URL: string = 'https://finance.dev.yoola.com';


// WEBPACK FOOTER //
// ./src/app/shared/global-vars.ts